import React, { useEffect } from "react";
import { push } from "connected-react-router";
import { connect } from 'react-redux';
import Slider from "react-slick";

import './styles/custom.css';

function NextArrow(props: any) {
	const { onClick } = props;
  return (
    <button
      className='slick_forward'
			onClick={onClick}
    >
			Далее
		</button>
  );
}

function PrevArrow(props: any) {
	const { onClick } = props;
  return (
    <button
      className="slick_backward"
			onClick={onClick}
    >
			Назад
		</button>
  );
}

interface IProps {
	goTo: (path: string) => void;
}

const IntroPage: React.FC<IProps> = ({ goTo }) => {
	useEffect(() => {
    document.body.classList.add('intro-open');
    return () => {
      document.body.classList.remove('intro-open');
    }
  }, []);

	const settings = {
		dots: true,
		infinite: true,
		speed: 500,
		slidesToShow: 1,
		slidesToScroll: 1,
		appendDots: (dots: any) => (
			<div>
				<ul className="slick_dots_container"> {dots} </ul>
			</div>
		),
		nextArrow: <NextArrow />,
		prevArrow: <PrevArrow />,
		beforeChange: (oldIndex: number, newIndex: number) => { if (oldIndex === 2 && newIndex === 0) goTo('home/dashboard')},
	}

  return (
		<main className="intro_page">
			<Slider {...settings}>
				<div className="slider-intro__item">
					<section className="slider-intro__picture">
						<div className="container">
							<div className="slider-intro__picture__image first_img"></div>
						</div>
					</section>
					<section className="slider-intro__text">
						<div className="container">
							<div className="row">
								<div className="col-sm-6 mb-5 mb-md-0 mb-sm-0 d-flex justify-content-center">
									<ul className="step-list">
										<li className="step-list__item step-list__item--numbers">1</li>
										<li className="step-list__item step-list__item--content">На карточке товара Вы найдёте подробное описание и видео по технике его продажи</li>
									</ul>
								</div>
								<div className="col-sm-6 d-flex justify-content-center">
									<ul className="step-list">
										<li className="step-list__item step-list__item--numbers">2</li>
										<li className="step-list__item step-list__item--content">Ваш бонус в случае продажи этого товара</li>
									</ul>
								</div>
							</div>
						</div>
					</section>
				</div>
				<div className="slider-intro__item">
					<section className="slider-intro__picture">
						<div className="container">
							<div className="slider-intro__picture__image second_img"></div>
						</div>
					</section>
					<section className="slider-intro__text">
						<div className="container">
							<div className="row">
								<div className="col-sm-6 mb-5 mb-md-0 mb-sm-0 d-flex justify-content-center">
									<ul className="step-list">
										<li className="step-list__item step-list__item--numbers">3</li>
										<li className="step-list__item step-list__item--content">Ваш заработок наглядно</li>
									</ul>
								</div>
								<div className="col-sm-6 d-flex justify-content-center">
									<ul className="step-list">
										<li className="step-list__item step-list__item--numbers">4</li>
										<li className="step-list__item step-list__item--content">На главном экране всегда актуальные акции и спецпредложения с повышенным Бонусом за продажи</li>
									</ul>
								</div>
							</div>
						</div>
					</section>
				</div>
				<div className="slider-intro__item">
					<section className="slider-intro__picture">
						<div className="container">
							<div className="slider-intro__picture__image third_img"></div>
						</div>
					</section>
					<section className="slider-intro__text">
						<div className="container">
							<div className="row">
								<div className="col-sm-6 mb-5 mb-md-0 mb-sm-0 d-flex justify-content-center">
									<ul className="step-list">
										<li className="step-list__item step-list__item--numbers">5</li>
										<li className="step-list__item step-list__item--content">Единая страница с историей сделок и Вашим доходом</li>
									</ul>
								</div>
								<div className="col-sm-6 d-flex justify-content-center">
									<ul className="step-list">
										<li className="step-list__item step-list__item--numbers">6</li>
										<li className="step-list__item step-list__item--content">Статусы каждой сделки и возможность просмотра детализации</li>
									</ul>
								</div>
							</div>
						</div>
					</section>
				</div>
			</Slider>
		</main>
	);
};

const actions = {
  goTo: push,
};

export default connect(null, actions)(IntroPage);
